module.exports = __webpack_public_path__ + "bb49bd4de29cffa4036db02c248bbe37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin/onboarding-tour-illo.svg
// module id = 1996
// module chunks = 0 1 3